(function () {
  'use strict';

  // The layout loads this once. Bail if a section ever includes it again, so click
  // handlers and pollers are not bound twice.
  if (window.DevinesApp) return;

  var SESSION_KEY = 'dv_session';
  var EMAIL_KEY = 'dv_session_email';
  // Reserved product handle used by the product-less support conversation.
  var SUPPORT_HANDLE = '__support__';
  var RESEND_SECS = 30;
  var emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  var resendTimer = null;
  var resendLeft = 0;

  function cfg() {
    var el = document.querySelector('[data-dv-rail-config]');
    if (!el) return { apiBase: '/apps/devines', chatPage: '/pages/chat' };
    try {
      return JSON.parse(el.textContent || '{}');
    } catch (e) {
      return { apiBase: '/apps/devines', chatPage: '/pages/chat' };
    }
  }

  function apiRoot() {
    var b = String((cfg().apiBase) || '').replace(/\/$/, '');
    if (!b || b === '/apps/devines') return '/apps/devines';
    return b;
  }

  function isProxy() {
    return apiRoot().indexOf('/apps/devines') >= 0;
  }

  function token() {
    try {
      return localStorage.getItem(SESSION_KEY) || '';
    } catch (e) {
      return '';
    }
  }

  /** App Proxy strips Authorization — attach session as query + header. */
  function withSession(url) {
    var t = token();
    if (!t) return url;
    var s = String(url);
    if (s.indexOf('/apps/devines') < 0 && s.indexOf('/api/offers') < 0 && s.indexOf('railway.app') < 0) return s;
    var join = s.indexOf('?') >= 0 ? '&' : '?';
    return s + join + 'dv_session=' + encodeURIComponent(t);
  }

  function headers() {
    var h = { 'Content-Type': 'application/json' };
    var t = token();
    if (t) {
      h.Authorization = 'Bearer ' + t;
      h['X-DV-Session'] = t;
    }
    return h;
  }

  function authUrl(path) {
    var r = apiRoot();
    var url = r.indexOf('/apps/devines') >= 0 ? r + '/auth/' + path : r + '/api/auth/' + path;
    return withSession(url);
  }

  function offersUrl(path) {
    var r = apiRoot();
    var url = r.indexOf('/apps/devines') >= 0 ? r + '/offers/' + path : r + '/api/offers/' + path;
    return withSession(url);
  }

  function esc(s) {
    return String(s || '').replace(/[&<>"']/g, function (c) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
    });
  }

  function timeAgo(ts) {
    if (!ts) return '';
    var sec = Math.max(0, Date.now() / 1000 - Number(ts));
    if (sec < 60) return 'just now';
    if (sec < 3600) return Math.floor(sec / 60) + ' min ago';
    if (sec < 86400) return Math.floor(sec / 3600) + ' hours ago';
    return Math.floor(sec / 86400) + ' days ago';
  }

  function emptyChatsHtml() {
    return (
      '<div class="dv-rail__empty-state">' +
      '<span class="dv-rail__empty-ico" aria-hidden="true">' +
      '<svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">' +
      '<path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg></span>' +
      '<strong>No chats yet</strong>' +
      '<span>Browse items and start a chat to buy</span></div>'
    );
  }

  function setAuthUi(loggedIn) {
    document.documentElement.classList.toggle('dv-chat-authed', !!loggedIn);
    document.body.classList.toggle('dv-rail-authed', !!loggedIn);
    var tools = document.querySelector('[data-dv-tools]');
    var loginBtn = document.querySelector('[data-dv-open-login]');
    if (tools) tools.hidden = !loggedIn;
    // login button in sidebar only (not guest card)
    document.querySelectorAll('.dv-rail__login[data-dv-open-login]').forEach(function (btn) {
      btn.hidden = !!loggedIn;
    });
  }

  function setOpen(open) {
    document.body.classList.toggle('dv-rail-open', open);
    document.documentElement.classList.toggle('dv-rail-open', open);
    var btn = document.querySelector('[data-dv-rail-toggle]');
    if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    var scrim = document.querySelector('[data-dv-rail-scrim]');
    if (scrim) scrim.hidden = !open;
    if (open) document.documentElement.setAttribute('scroll-lock', '');
    else document.documentElement.removeAttribute('scroll-lock');
  }

  function bindRailUi() {
    document.querySelectorAll('[data-dv-rail-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        setOpen(!document.body.classList.contains('dv-rail-open'));
      });
    });
    document.querySelectorAll('[data-dv-rail-scrim]').forEach(function (el) {
      el.addEventListener('click', function () { setOpen(false); });
    });
    window.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') setOpen(false);
    });
    window.addEventListener('resize', function () {
      if (window.matchMedia('(min-width: 990px)').matches) setOpen(false);
    });
  }

  async function checkAuth() {
    if (!token()) {
      setAuthUi(false);
      return false;
    }
    try {
      var res = await fetch(authUrl('me'), { headers: headers(), credentials: 'same-origin' });
      var data = await res.json().catch(function () { return {}; });
      var ok = !!(data.authenticated && data.email);
      if (ok) {
        try { localStorage.setItem(EMAIL_KEY, data.email); } catch (e) {}
      }
      // Don't wipe token on a soft false — proxy/signature glitches happen.
      // Only clear when the API explicitly rejects with 401.
      if (!ok && res.status === 401) {
        try {
          localStorage.removeItem(SESSION_KEY);
          localStorage.removeItem(EMAIL_KEY);
        } catch (e) {}
        setAuthUi(false);
        return false;
      }
      // Optimistic: any local session token counts as signed-in for UI
      if (!ok && token()) {
        setAuthUi(true);
        return true;
      }
      setAuthUi(ok);
      return ok;
    } catch (e) {
      if (token()) {
        setAuthUi(true);
        return true;
      }
      setAuthUi(false);
      return false;
    }
  }

  function chatPagePath() {
    var p = String((cfg().chatPage) || '/pages/chat').trim();
    if (!p || p.indexOf('shopify://') === 0) return '/pages/chat';
    try {
      if (/^https?:/i.test(p)) return new URL(p).pathname || '/pages/chat';
    } catch (e) {}
    return p.charAt(0) === '/' ? p : '/' + p;
  }

  function isChatAppPage() {
    return !!(document.querySelector('.dv-app') || document.body.classList.contains('dv-chat-page-body'));
  }

  function isNarrow() {
    try { return window.matchMedia('(max-width: 989px)').matches; } catch (e) { return false; }
  }

  function preferredThreadId(threads) {
    var params = new URLSearchParams(location.search);
    var fromUrl = params.get('thread');
    if (fromUrl) return String(fromUrl);
    var product = params.get('product') || params.get('handle');
    if (product && threads && threads.length) {
      var match = threads.find(function (t) {
        return String(t.product_handle) === String(product);
      });
      if (match && match.id != null) return String(match.id);
    }
    // New product chat — don't auto-open an unrelated thread
    if (product) return '';
    if (threads && threads[0] && threads[0].id != null) return String(threads[0].id);
    return '';
  }

  var pendingOpenThreadId = null;

  function requestOpenThread(id) {
    if (id == null || id === '') return;
    var next = Number(id);
    if (!next || !isFinite(next)) return;
    // Skip re-emit if we already asked for this thread (stops reload flicker)
    if (pendingOpenThreadId === next && document.documentElement.classList.contains('dv-chat-authed')) {
      var active = document.querySelector('.dv-rail-chat.is-active');
      if (active && String(active.getAttribute('data-thread-id')) === String(next)) {
        return;
      }
    }
    pendingOpenThreadId = next;
    document.dispatchEvent(new CustomEvent('dv:open-thread', { detail: { id: pendingOpenThreadId } }));
  }

  async function loadChats() {
    var list = document.querySelector('[data-dv-chat-list]');
    var count = document.querySelector('[data-dv-chat-count]');
    if (!list) return;
    if (!token()) {
      list.innerHTML = emptyChatsHtml();
      if (count) count.textContent = '0';
      return;
    }
    try {
      var res = await fetch(offersUrl('threads'), { headers: headers(), credentials: 'same-origin' });
      var data = await res.json().catch(function () { return {}; });
      if (!res.ok) {
        list.innerHTML = emptyChatsHtml();
        return;
      }
      var threads = data.threads || [];
      if (count) count.textContent = String(threads.length);
      var chatPage = chatPagePath();
      var active = preferredThreadId(threads);
      if (!threads.length) {
        list.innerHTML = emptyChatsHtml();
        return;
      }
      list.innerHTML = threads.map(function (t) {
        var href = chatPage + (chatPage.indexOf('?') >= 0 ? '&' : '?') + 'thread=' + encodeURIComponent(t.id);
        var activeCls = String(active) === String(t.id) ? ' is-active' : '';
        var support = String(t.product_handle || '') === SUPPORT_HANDLE;
        // Support threads have no product, so show a bubble glyph instead of a blank tile.
        var img = support
          ? '<span class="dv-rail-chat__ico" aria-hidden="true">' +
            '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg></span>'
          : (t.product_image
            ? '<img src="' + esc(t.product_image) + '" alt="">'
            : '<img alt="" src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==">');
        var when = timeAgo(t.updated_at || t.last_message_at || t.created_at);
        var msgLabel = t.message_count != null
          ? (Number(t.message_count) + ' messages')
          : (t.last_message ? '1+ messages' : '0 messages');
        var title = support
          ? (t.product_title || 'Support')
          : (t.product_title || t.product_handle);
        return (
          '<a class="dv-rail-chat' + activeCls + (support ? ' dv-rail-chat--support' : '') +
          '" href="' + esc(href) + '" data-thread-id="' + esc(t.id) + '">' +
          img +
          '<span><strong>' + esc(title) + '</strong>' +
          '<em>' + esc(when) + ' · ' + esc(msgLabel) + '</em></span></a>'
        );
      }).join('');

      // Chat page: open thread from URL (product param handled by devines-chat section)
      if (isChatAppPage()) {
        var params = new URLSearchParams(location.search);
        var pendingProduct = params.get('product') || params.get('handle');
        // On mobile the list is a screen of its own: only open a conversation the URL
        // actually asked for, never the most recent one.
        var want;
        if (params.get('thread')) want = params.get('thread');
        else if (pendingProduct || params.get('support')) want = active;
        else if (isNarrow()) want = '';
        else want = active || (threads[0] && threads[0].id);
        var current = document.documentElement.getAttribute('data-dv-open-thread');
        if (want && String(current) !== String(want)) {
          requestOpenThread(want);
        }
      }
    } catch (e) {
      list.innerHTML = emptyChatsHtml();
    }
  }

  function bindChatClicks() {
    document.addEventListener('click', function (e) {
      var a = e.target && e.target.closest && e.target.closest('.dv-rail-chat');
      if (!a) return;
      var id = a.getAttribute('data-thread-id');
      if (!id) {
        var href = a.getAttribute('href') || '';
        var m = href.match(/[?&]thread=(\d+)/);
        id = m && m[1];
      }
      if (!id) return;
      if (isChatAppPage()) {
        e.preventDefault();
        document.querySelectorAll('.dv-rail-chat.is-active').forEach(function (el) {
          el.classList.remove('is-active');
        });
        a.classList.add('is-active');
        requestOpenThread(id);
        setOpen(false);
      }
    });
  }

  function bindOrders() {
    var modal = document.getElementById('DvOrdersModal');
    if (!modal) return;
    document.querySelectorAll('[data-dv-orders]').forEach(function (btn) {
      btn.addEventListener('click', async function () {
        if (!token()) {
          openAuthModal();
          return;
        }
        modal.hidden = false;
        void modal.offsetWidth;
        modal.classList.add('is-open');
        var box = modal.querySelector('[data-dv-orders-list]');
        box.innerHTML = '<p class="dv-rail-muted">Loading…</p>';
        try {
          var res = await fetch(offersUrl('my-orders'), { headers: headers(), credentials: 'same-origin' });
          var data = await res.json().catch(function () { return {}; });
          if (!res.ok) {
            box.innerHTML = '<p class="dv-rail-muted">' + esc(data.detail || 'Could not load orders') + '</p>';
            return;
          }
          if (!(data.orders || []).length) {
            box.innerHTML = '<p class="dv-rail-muted">No orders for ' + esc(data.email || 'this email') + '.</p>';
            return;
          }
          box.innerHTML = data.orders.map(function (o) {
            var items = (o.line_items || []).map(function (li) { return esc(li.title); }).join(', ');
            var link = o.order_status_url
              ? ' · <a href="' + esc(o.order_status_url) + '" target="_blank" rel="noopener">Track</a>'
              : '';
            return (
              '<div class="dv-rail-order"><strong>' + esc(o.name) + '</strong>' +
              '<div>' + esc(o.total_price) + ' ' + esc(o.currency) +
              ' · ' + esc(o.financial_status) + ' · ' + esc(o.fulfillment_status) + link + '</div>' +
              (items ? '<div class="dv-rail-muted">' + items + '</div>' : '') +
              '</div>'
            );
          }).join('');
        } catch (e) {
          box.innerHTML = '<p class="dv-rail-muted">Could not load orders</p>';
        }
      });
    });
    modal.querySelectorAll('[data-dv-orders-close]').forEach(function (el) {
      el.addEventListener('click', function () {
        modal.classList.remove('is-open');
        setTimeout(function () { modal.hidden = true; }, 220);
      });
    });
  }

  function bindLogout() {
    var modal = document.getElementById('DvLogoutModal');
    if (!modal) return;

    function openLogout() {
      modal.hidden = false;
      void modal.offsetWidth;
      modal.classList.add('is-open');
    }
    function closeLogout() {
      modal.classList.remove('is-open');
      setTimeout(function () { modal.hidden = true; }, 220);
    }
    function confirmLogout() {
      try {
        localStorage.removeItem(SESSION_KEY);
        localStorage.removeItem(EMAIL_KEY);
      } catch (e) {}
      setAuthUi(false);
      loadChats();
      closeLogout();
      var chatPage = cfg().chatPage || '/pages/chat';
      if (document.querySelector('.dv-app')) {
        window.location.href = chatPage;
      }
    }

    document.querySelectorAll('[data-dv-logout]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        openLogout();
      });
    });
    modal.querySelectorAll('[data-dv-logout-cancel]').forEach(function (el) {
      el.addEventListener('click', closeLogout);
    });
    modal.querySelectorAll('[data-dv-logout-confirm]').forEach(function (el) {
      el.addEventListener('click', confirmLogout);
    });
  }

  // The rail ships its own copy with the merchant's wording; the layout copy is the
  // fallback for pages without a rail. Only one survives, see dedupeAuthModal.
  function authModal() {
    return document.getElementById('DvRailAuthModal') || document.getElementById('DvAuthModal');
  }

  // Two copies would mean duplicate email and one-time-code fields for autofill, so drop
  // the layout one wherever the rail provides its own.
  function dedupeAuthModal() {
    var global = document.getElementById('DvAuthModal');
    if (global && document.getElementById('DvRailAuthModal')) global.remove();
  }

  function authStep(name) {
    var modal = authModal();
    if (!modal) return;
    modal.querySelectorAll('[data-dv-rail-auth-step]').forEach(function (el) {
      el.hidden = el.getAttribute('data-dv-rail-auth-step') !== name;
    });
    modal.querySelectorAll('[data-dv-rail-auth-err]').forEach(function (el) {
      el.hidden = true;
      el.textContent = '';
    });
  }

  function authErr(msg) {
    var modal = authModal();
    if (!modal) return;
    var step = modal.querySelector('[data-dv-rail-auth-step]:not([hidden])');
    var err = step && step.querySelector('[data-dv-rail-auth-err]');
    if (err) {
      err.hidden = false;
      err.textContent = msg;
    }
  }

  function otpCells() {
    var modal = authModal();
    return modal ? Array.prototype.slice.call(modal.querySelectorAll('.dv-auth-otp__cell')) : [];
  }

  function getOtp() {
    return otpCells().map(function (c) { return c.value || ''; }).join('');
  }

  function clearOtp() {
    otpCells().forEach(function (c) { c.value = ''; });
  }

  function startResendCountdown() {
    clearInterval(resendTimer);
    resendLeft = RESEND_SECS;
    var modal = authModal();
    if (!modal) return;
    var btn = modal.querySelector('[data-dv-rail-auth-resend]');
    var timerEl = modal.querySelector('[data-dv-rail-auth-timer]');
    function tick() {
      if (resendLeft <= 0) {
        clearInterval(resendTimer);
        if (btn) { btn.disabled = false; btn.textContent = 'Resend'; }
        if (timerEl) timerEl.textContent = '';
        return;
      }
      if (btn) { btn.disabled = true; btn.textContent = 'Resend'; }
      if (timerEl) timerEl.textContent = '(' + resendLeft + 's)';
      resendLeft -= 1;
    }
    tick();
    resendTimer = setInterval(tick, 1000);
  }

  function openAuthModal() {
    var modal = authModal();
    if (!modal) {
      // Nothing to show, so undo any pre-paint hiding of the page behind it.
      document.documentElement.classList.remove('dv-auth-open');
      return;
    }
    if (modal.parentElement !== document.body) document.body.appendChild(modal);
    authStep('email');
    clearOtp();
    modal.hidden = false;
    void modal.offsetWidth;
    modal.classList.add('is-open');
    // Lets the chat page hide its own guest panel, so only this popup is on screen.
    document.documentElement.classList.add('dv-auth-open');
    document.body.style.overflow = 'hidden';
    var emailInput = modal.querySelector('[data-dv-rail-auth-email]');
    if (emailInput) setTimeout(function () { emailInput.focus(); }, 60);
  }

  var loginPromptShown = false;

  // Opens the login popup at most once per page load, so dismissing it sticks.
  function promptLogin() {
    if (loginPromptShown) return;
    loginPromptShown = true;
    openAuthModal();
  }

  // Where to go once the code is accepted, when login was triggered by a link that we
  // held back. Empty means stay on this page.
  var postLoginHref = '';

  // Dim the current page, then navigate. Mirrors the product page's chat transition so
  // the chat page fades in the same way.
  function fadeTo(url) {
    try { sessionStorage.setItem('dv_chat_enter', '1'); } catch (e) {}
    var overlay = document.querySelector('.dv-page-fade') || document.createElement('div');
    overlay.className = 'dv-page-fade';
    if (!overlay.parentElement) document.body.appendChild(overlay);
    void overlay.offsetWidth;
    overlay.classList.add('is-on');
    setTimeout(function () { window.location.href = url; }, 180);
  }

  function closeAuthModal() {
    var modal = authModal();
    if (!modal) return;
    modal.classList.remove('is-open');
    clearInterval(resendTimer);
    setTimeout(function () {
      modal.hidden = true;
      document.documentElement.classList.remove('dv-auth-open');
      document.body.style.overflow = '';
    }, 280);
  }

  // The chat page is empty until you log in, so dismissing the popup there sends the
  // customer back where they came from rather than to a blank screen.
  function dismissAuthModal() {
    var gated = isChatAppPage() && !token();
    postLoginHref = '';
    closeAuthModal();
    if (!gated) return;
    setTimeout(function () {
      if (token()) return;
      if (history.length > 1) history.back();
      else window.location.href = '/';
    }, 220);
  }

  // The header chat icon sits on every page. While logged out it must not navigate: the
  // login popup opens over the page you are on, and only a verified code moves you to
  // chat.
  function bindHeaderChat() {
    document.addEventListener('click', function (e) {
      var link = e.target && e.target.closest && e.target.closest('[data-dv-header-chat]');
      if (!link || token() || !authModal()) return;
      e.preventDefault();
      if (isChatAppPage()) {
        // Already here, so there is nowhere to go afterwards.
        postLoginHref = '';
      } else {
        var href = link.getAttribute('href') || '';
        if (!href || href.indexOf('shopify://') === 0) href = chatPagePath();
        postLoginHref = href;
      }
      openAuthModal();
    });
  }

  function bindAuthModal() {
    var modal = authModal();
    if (!modal) return;

    document.querySelectorAll('[data-dv-open-login]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        openAuthModal();
      });
    });
    modal.querySelectorAll('[data-dv-rail-auth-close]').forEach(function (el) {
      el.addEventListener('click', dismissAuthModal);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) dismissAuthModal();
    });

    var cells = otpCells();
    cells.forEach(function (cell, i) {
      cell.addEventListener('input', function () {
        var v = cell.value.replace(/\D/g, '');
        if (v.length > 1) {
          var chars = v.slice(0, cells.length - i).split('');
          chars.forEach(function (ch, j) {
            if (cells[i + j]) cells[i + j].value = ch;
          });
          var next = cells[Math.min(i + chars.length, cells.length - 1)];
          if (next) next.focus();
        } else {
          cell.value = v.slice(0, 1);
          if (v && cells[i + 1]) cells[i + 1].focus();
        }
      });
      cell.addEventListener('keydown', function (e) {
        if (e.key === 'Backspace' && !cell.value && cells[i - 1]) {
          cells[i - 1].focus();
          cells[i - 1].value = '';
          e.preventDefault();
        }
        if (e.key === 'Enter') {
          e.preventDefault();
          modal.querySelector('[data-dv-rail-auth-verify]')?.click();
        }
      });
      cell.addEventListener('paste', function (e) {
        var text = (e.clipboardData || window.clipboardData).getData('text') || '';
        var digits = text.replace(/\D/g, '').slice(0, 6).split('');
        if (!digits.length) return;
        e.preventDefault();
        cells.forEach(function (c, j) { c.value = digits[j] || ''; });
        cells[Math.min(digits.length, cells.length - 1)].focus();
      });
    });

    modal.querySelector('[data-dv-rail-auth-send]')?.addEventListener('click', async function (e) {
      var b = e.currentTarget;
      var email = (modal.querySelector('[data-dv-rail-auth-email]').value || '').trim();
      if (!emailRe.test(email)) {
        authErr('Please enter a valid email');
        return;
      }
      b.disabled = true;
      try {
        var res = await fetch(authUrl('request-code').split('?')[0], {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email: email })
        });
        // request-code doesn't need session — strip query if withSession added empty
        var data = await res.json().catch(function () { return {}; });
        if (!res.ok) throw new Error((typeof data.detail === 'string' ? data.detail : null) || 'Could not send code');
        try { localStorage.setItem(EMAIL_KEY, email); } catch (ex) {}
        modal.querySelectorAll('[data-dv-rail-auth-email-shown]').forEach(function (el) {
          el.textContent = email;
        });
        authStep('otp');
        clearOtp();
        startResendCountdown();
        var first = otpCells()[0];
        if (first) setTimeout(function () { first.focus(); }, 50);
      } catch (ex) {
        authErr(ex.message || 'Could not send code');
      } finally {
        b.disabled = false;
      }
    });

    modal.querySelector('[data-dv-rail-auth-resend]')?.addEventListener('click', async function (e) {
      var email = (modal.querySelector('[data-dv-rail-auth-email]').value || '').trim() ||
        (localStorage.getItem(EMAIL_KEY) || '');
      if (!emailRe.test(email)) return;
      e.currentTarget.disabled = true;
      try {
        await fetch(apiRoot() + '/auth/request-code', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email: email })
        });
        startResendCountdown();
      } catch (ex) {
        e.currentTarget.disabled = false;
      }
    });

    modal.querySelector('[data-dv-rail-auth-verify]')?.addEventListener('click', async function (e) {
      var b = e.currentTarget;
      var email = (modal.querySelector('[data-dv-rail-auth-email]').value || '').trim() ||
        (localStorage.getItem(EMAIL_KEY) || '');
      var code = getOtp();
      if (code.length < 6) {
        authErr('Enter the 6-digit code from your email');
        return;
      }
      b.disabled = true;
      try {
        var res = await fetch(apiRoot() + '/auth/verify', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email: email, code: code })
        });
        var data = await res.json().catch(function () { return {}; });
        if (!res.ok) throw new Error((typeof data.detail === 'string' ? data.detail : null) || 'Invalid or expired code');
        try {
          localStorage.setItem(SESSION_KEY, data.token);
          localStorage.setItem(EMAIL_KEY, data.email || email);
        } catch (ex) {}
        setAuthUi(true);
        var dest = postLoginHref;
        postLoginHref = '';
        closeAuthModal();
        // Login was opened in place by a held-back link, so honour it now.
        if (dest) {
          fadeTo(dest);
          return;
        }
        await loadChats();
        document.dispatchEvent(new CustomEvent('dv:auth', { detail: { email: data.email || email } }));
      } catch (ex) {
        authErr(ex.message || 'Invalid or expired code');
      } finally {
        b.disabled = false;
      }
    });

    modal.querySelector('[data-dv-rail-auth-back]')?.addEventListener('click', function () {
      clearOtp();
      authStep('email');
    });
    modal.querySelector('[data-dv-rail-auth-reset]')?.addEventListener('click', function () {
      clearOtp();
      authStep('email');
    });

    modal.querySelector('[data-dv-rail-auth-email]')?.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        modal.querySelector('[data-dv-rail-auth-send]')?.click();
      }
    });
  }

  // Fade the product page in when arriving from the chat's back chevron. The classes are
  // always torn down on a timer so a missed frame can never leave the page invisible.
  function playPdpEnter() {
    var flag = null;
    try {
      flag = sessionStorage.getItem('dv_pdp_enter');
      sessionStorage.removeItem('dv_pdp_enter');
    } catch (e) {}
    if (!flag) return;
    var root = document.documentElement;
    root.classList.add('dv-pdp-enter');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { root.classList.add('dv-pdp-enter-done'); });
    });
    setTimeout(function () {
      root.classList.remove('dv-pdp-enter');
      root.classList.remove('dv-pdp-enter-done');
    }, 700);
  }

  async function boot() {
    playPdpEnter();
    dedupeAuthModal();

    // No rail on this page (home, collections, cart…). The header chat icon still needs
    // to log guests in over the page they are on, so wire up just that much.
    if (!document.querySelector('[data-dv-rail]')) {
      bindAuthModal();
      bindHeaderChat();
      return;
    }
    document.documentElement.classList.add('has-dv-rail');
    document.body.classList.add('has-dv-rail');

    ['DvLogoutModal', 'DvOrdersModal', 'DvRailAuthModal'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el && el.parentElement !== document.body) document.body.appendChild(el);
    });

    // Optimistic UI from localStorage before network
    setAuthUi(!!token());
    bindRailUi();
    bindChatClicks();
    bindOrders();
    bindLogout();
    bindAuthModal();
    bindHeaderChat();

    // On the chat page there is nothing to read until you log in, so surface the
    // login popup straight away rather than making people click the guest screen.
    if (isChatAppPage() && !token()) promptLogin();

    var ok = await checkAuth();
    if (ok) await loadChats();
    else {
      var list = document.querySelector('[data-dv-chat-list]');
      if (list) list.innerHTML = emptyChatsHtml();
      // Covers an expired token, where localStorage looked valid a moment ago.
      if (isChatAppPage()) promptLogin();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.DevinesApp = {
    token: token,
    headers: headers,
    withSession: withSession,
    offersUrl: offersUrl,
    authUrl: authUrl,
    apiRoot: apiRoot,
    esc: esc,
    timeAgo: timeAgo,
    cfg: cfg,
    chatPagePath: chatPagePath,
    SESSION_KEY: SESSION_KEY,
    EMAIL_KEY: EMAIL_KEY,
    refreshChats: loadChats,
    setRailOpen: setOpen,
    openAuthModal: openAuthModal,
    setAuthUi: setAuthUi,
    checkAuth: checkAuth,
    requestOpenThread: requestOpenThread,
    getPendingThreadId: function () { return pendingOpenThreadId; }
  };
})();
